import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map } from 'rxjs/operators';



@Injectable()
export class CustomerService {

  constructor(private base: BaseService) { }


  save(data){
    return this.base.post('/api/customer-save', data);
  }

  getAllCustomer(){
    return this.base.get('/api/all-customer');
  }

  getCustomer(id){
 
    return this.base.post('/api/get-customer',{id:id});
  }

  customerUpdate(data){
    return this.base.post('/api/customer-update',data);
  }

  getCustomerInfo(data){
    return this.base.post('/api/get-customer-info',{id:data});
  }

}
